import { useState } from "react";
import { TENANT_LOGO_URL, useTenant } from "config/tenant";

/**
 * Logo de la société exploitante.
 *
 * Le bundle frontend est commun à toutes les sociétés : il ne peut donc
 * embarquer le sigle d'aucune. Le logo est servi par le backend depuis le
 * répertoire `tenant/` de la société (`GET /api/tenant/logo`).
 *
 * Sans logo fourni, on affiche la **raison sociale en texte** — jamais le
 * sigle d'une autre société. C'est le lien inter-sociétés le plus voyant qui
 * soit : ce composant s'affiche sur l'écran de connexion et dans la barre de
 * navigation de chaque page.
 *
 * @param {object} p
 * @param {string} [p.className] - classes de l'image
 * @param {string} [p.collapsed] - barre de navigation repliée : initiales
 */
export default function TenantLogo({ className = "", collapsed = false }) {
  const { name, shortName, hasLogo } = useTenant();
  const [failed, setFailed] = useState(false);

  const label = collapsed ? shortName || name : name;

  // Tant que l'identité n'est pas connue, ne rien afficher : une case vide
  // pendant quelques dizaines de millisecondes vaut mieux qu'un sigle qui
  // change sous les yeux de l'utilisateur.
  if (!name && !shortName) return null;

  if (!hasLogo || failed) {
    return (
      <span className={`fw-semibold text-nowrap ${className}`} title={name}>
        {label}
      </span>
    );
  }

  return (
    <img
      className={className}
      src={TENANT_LOGO_URL}
      alt={name}
      // Si le fichier devient illisible côté serveur, on retombe sur le texte
      // plutôt que sur une image cassée.
      onError={() => setFailed(true)}
    />
  );
}
